// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <wt-line-chart class=\"flex-directive\" id=\"tickets-trend\" chart-data=\"vm.data\" series=\"vm.series\" options=\"vm.options\" zoom-control=\"vm.zoomControl\"></wt-line-chart> </div>";
// Exports
module.exports = code;